// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OhlP","name":"styles_name__9JUbf","phone":"styles_phone__2Rwe4"};